module.exports = __webpack_public_path__ + "static/zigzag-image2-9ac80f4d9f1b971c11f7dc1c2affa5f7.png";